import md5 from 'js-md5';
export const getFirstPartOfDomain = (url) => {
  // const parts = url.split('.');
  // if (parts.length > 1) {
  //   return parts[0];
  // }
  // return null; // 没有点或者只有一个点，无法确定第一部分

  const regex = new RegExp('/' + '(.*?)' + '/download', 's');
  const match = url.match(regex);
  return match ? match[1] : '';
};

export function isMobile() {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
}

export const getDomainFromUrl = (url) => {
  const regex = /^https?:\/\/([^\/]+)/i;
  const match = url.match(regex);
  if (match && match[1]) {
    return match[1];
  }
  return null;
};

export const isGoogleChrome = () => {
  const userAgent = navigator.userAgent;
  const isChrome =
    /Chrome\/\d+/.test(userAgent) &&
    !/Edg|OPR|Firefox|Safari\/\d+.$/.test(userAgent);
  return isChrome;
};

export const setLocalStorage = (key, obj) => {
  localStorage.setItem(key, JSON.stringify(obj));
};

// 获取localStorage中存储的对象
export const getLocalStorage = (key) => {
  var object = localStorage.getItem(key);
  if (object) {
    return JSON.parse(object);
  }
  return null;
};

// 设置对象中特定属性的值
export const setKeyInLocalStorage = (key, property, value) => {
  var obj = getLocalStorage(key) || {};
  obj[property] = value;
  setLocalStorage(key, obj);
};

export const urlB64ToUint8Array = (base64String) => {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
};

export const getDeviceId = () => {
  const device = md5(navigator.userAgent.replace(/[^\w]/gi, ''));
  return `h5id_${device.substring(0, 16)}`;
};

export const getIdentification = (identification) => {
  const uAgent = navigator.userAgent;
  const randomNumber = Math.floor(Math.random() * 90000) + 10000; // 5位随机数
  const getTime = new Date().getTime();
  const userAgent = uAgent + randomNumber + getTime;
  return `${md5(identification).substr(8, 16)}-${md5(userAgent).substr(8, 16)}`;
};

export const enhancedChromeLauncher = (url, callback) => {
  const startTime = Date.now();
  let timer;

  // 尝试唤起应用
  const tryLaunch = () => {
    window.location.href = `intent://${url.split('://')[1]}#Intent;scheme=${
      url.split(':')[0]
    };package=com.android.chrome;end`;

    // 检测是否唤起成功
    timer = setInterval(() => {
      if (document.hidden) {
        clearInterval(timer);
      } else if (Date.now() - startTime > 1000) {
        clearInterval(timer);
        callback();
      }
    }, 100);
  };

  tryLaunch();
};

// 设置主题颜色
export const setThemeColor = (themeColor) => {
  const root = document.documentElement;
  root.style.setProperty(
    `--main-color`,
    themeColor === '' ? '#00956D' : themeColor
  );
  root.style.setProperty(
    `--main-color-hover`,
    themeColor === '' ? '#00956D' : themeColor
  );
};
